export default __webpack_public_path__ + "static/podcast-39105b68251ed51d9a20549ccaf42e8f.mp4";